import { useCallback, useState } from 'react';

export type Theme = 'light' | 'dark';

const KEY = 'fleece.theme';

function current(): Theme {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

/** The theme index.html chose before first paint, and a toggle that remembers the choice. */
export function useTheme(): readonly [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(current);
  const toggle = useCallback(() => {
    const next: Theme = current() === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Storage refused (private mode): the choice lasts this visit, which is all it can.
    }
    setTheme(next);
  }, []);
  return [theme, toggle];
}
